class OccupationPhotoSwiper {
  constructor(root) {
    this.root = typeof root === 'string' ? document.querySelector(root) : root;
    this.swiper = null;

    if (!this.root || typeof Swiper === 'undefined') {
      return;
    }

    this.init();
  }

  getSpaceBetweenPx() {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (Number.isNaN(rootFontSize)) {
      return 32;
    }

    return window.matchMedia('(max-width: 767px)').matches ? rootFontSize * 1.6 : rootFontSize * 3.2;
  }

  init() {
    this.swiper = new Swiper(this.root, {
      slidesPerView: 'auto',
      spaceBetween: this.getSpaceBetweenPx(),
      loop: true,
      speed: 6000,
      allowTouchMove: true,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      touchStartPreventDefault: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
    });

    this.bindRecoveryEvents();
    this.bindTabVisibility();
  }

  bindTabVisibility() {
    const panel = this.root.closest('.c-occupation__day-panel');

    if (!panel) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (panel.classList.contains('is-active')) {
        this.restartAutoplay();
      }
    });

    observer.observe(panel, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  restartAutoplay() {
    if (!this.swiper || this.swiper.destroyed) {
      return;
    }

    this.swiper.update();

    if (this.swiper.autoplay) {
      this.swiper.autoplay.stop();
      this.swiper.autoplay.start();
    }
  }

  bindRecoveryEvents() {
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.restartAutoplay();
      }
    });

    window.addEventListener('focus', () => {
      if (
        this.swiper &&
        this.swiper.autoplay &&
        (!this.swiper.autoplay.running || this.swiper.autoplay.paused)
      ) {
        this.restartAutoplay();
      }
    });

    window.addEventListener('resize', () => {
      if (!this.swiper || this.swiper.destroyed) {
        return;
      }

      this.swiper.params.spaceBetween = this.getSpaceBetweenPx();
      this.swiper.update();
    });

    // Android 等で autoplay が止まる場合に備え、スワイプ後も再開
    this.root.addEventListener('touchend', () => {
      window.setTimeout(() => this.restartAutoplay(), 300);
    });
  }
}
